const THEME_PRIMARY = "#3c9aff"

export const colors = {
  // Marketplaces colors
  autouncle: "#1298CC",
  mobile: "#FF5E24",
  autoscout24: "#F6F142",
  "automobile.it": "#BD4B00",
  subito: "#F9423A",

  // Black
  black: "#000",
  // White
  white: "#FFF",
  // Transparent
  transparent: "transparent",

  // Used for numbered cards for Business Booster Landing Page only
  gradient_blue: "#D1F1FA",
  gradient_red: "#FAD1D1",
  gradient_green: "#D1FAD1",

  // Cool
  gray_100: "#f5f8fb",
  gray_200: "#d4e3f5",
  gray_300: "#b5d0ef",
  gray_400: "#95afcd",
  gray_500: "#7890ab",
  gray_600: "#5c7189",
  gray_700: "#425367",
  gray_800: "#2a3745",
  gray_900: "#0a0d10",

  // Blue dark
  blue_100: "#e6f2ff",
  blue_200: "#add4ff",
  blue_300: "#74b7ff",
  blue_400: THEME_PRIMARY,
  blue_500: "#036fe3",
  blue_600: "#0055b0",
  blue_700: "#003c7d",
  blue_800: "#00244a",
  blue_900: "#000c19",

  // Blue light
  variant_50: "#ecfbff",
  variant_100: "#ecfbff",
  variant_200: "#c0f1ff",
  variant_300: "#95e8ff",
  variant_400: "#6adfff",
  variant_500: "#3fd5ff",
  variant_600: "#1badd5",
  variant_700: "#0180a2",
  variant_800: "#00576f",
  variant_900: "#002833",

  // Green Successfull
  green_100: "#f5fffa",
  green_200: "#d8ffec",
  green_300: "#bbffde",
  green_400: "#9dfdcf",
  green_500: "#77d4a7",
  green_600: "#52a37c",
  green_700: "#3a835f",
  green_800: "#235a3f",
  green_900: "#0e251a",

  // Orange Attention
  orange_100: "#fff3e9",
  orange_200: "#ffcfa8",
  orange_300: "#ffab66",
  orange_400: "#f28023",
  orange_500: "#c7620f",
  orange_600: "#9e4801",
  orange_700: "#763500",
  orange_800: "#4d2300",
  orange_900: "#190b00",

  // Red Error
  red_100: "#ffecec",
  red_200: "#ffb3b3",
  red_300: "#ff7b7b",
  red_400: "#fa5050",
  red_500: "#de2b2b",
  red_600: "#ba1717",
  red_700: "#910808",
  red_800: "#680000",
  red_900: "#190000",

  info: THEME_PRIMARY,
  error: "#F01010",
  success: "#66BB6A",
  warning: "#FFA726",

  // Price Rating - DEPRECATED
  // These are used in the custom Price Rating component
  // Should be removed when the component is replaced with the UI library one
  expensive: "#a50600", // 1
  overpriced: "#9a6700", // 2
  fair: "#00838a", // 3
  good: "#4d7d00", // 4
  super: "#0a8020", // 5

  // Price Rating
  rating_0: "#d4e3f5",
  rating_1: "#a50600",
  rating_2: "#9a6700",
  rating_3: "#00838a",
  rating_4: "#4d7d00",
  rating_5: "#0a8020",
} as const

// Make sure to update PaddingType when making changes to spacing array
export const spacing = [
  "0px", // 0
  "4px", // 1
  "8px", // 2
  "12px", // 3
  "16px", // 4
  "24px", // 5
  "32px", // 6
  "40px", // 7
  "48px", // 8
  "64px", // 9
  "80px", // 10
] as const

export type PaddingType = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10

export const width = {
  "1/10": "10%",
  "1/5": "20%",
  "1/4": "25%",
  "3/10": "30%",
  "1/3": "33%",
  "2/5": "40%",
  "1/2": "50%",
  "3/5": "60%",
  "2/3": "66%",
  "7/10": "70%",
  "3/4": "75%",
  "4/5": "80%",
  "9/10": "90%",
  full: "100%",
  inherit: "inherit",
  auto: "auto",
  maxContent: "max-content",
  content: "950px",
} as const

export const radius = {
  full: "30px",
  large: "16px",
  medium: "8px",
  small: "4px",
  sharp: "0px",
} as const

export const justify = {
  start: "flex-start",
  end: "flex-end",
  center: "center",
  between: "space-between",
  around: "space-around",
  evenly: "space-evenly",
} as const

export const align = {
  start: "flex-start",
  end: "flex-end",
  center: "center",
  baseline: "baseline",
  stretch: "stretch",
} as const

export const content = {
  start: "flex-start",
  end: "flex-end",
  center: "center",
  between: "space-between",
  around: "space-around",
  evenly: "space-evenly",
} as const

const shadows = {
  shadow_base:
    "0px 1px 2px rgba(0, 0, 0, 0.06), 0px 1px 3px rgba(0, 0, 0, 0.1);",
  shadow_50: "0px 4px 24px rgba(2, 35, 76, 0.08);",
  shadow_100: "0px 8px 40px rgba(2, 35, 76, 0.16);",
} as const

const fonts = {
  fontDisplay: "Manrope, system-ui, sans-serif",
  fontBody: "Inter, system-ui, sans-serif",
  fontSerif: "Lora, Charter, 'Bitstream Charter', 'Sitka Text', Cambria, serif",
} as const

export const theme = {
  ...colors,
  ...shadows,
  ...fonts,
  spacing,
  width,
  align,
  justify,
  content,
  radius,
}
